// AboutSection.jsx
import React from "react";
import img1 from "../assets/img1.jpg";
import img2 from "../assets/img2.jpg";
import why1 from "../assets/why1.jpg";
import why2 from "../assets/why2.jpg";

const AboutSection = () => {
  return (
    <div>
      <section
        className="py-5 position-relative"
        style={{ backgroundColor: "#0B2F6A" }}
      >
        <div className="container">
          <div className="row align-items-center ms-lg-5 me-lg-5">
            <div className="col-lg-6 position-relative mb-4 mb-lg-0">
              <div className="position-relative">
                <img
                  src={why1}
                  alt="Compassionate Care"
                  className="img-fluid rounded-4 shadow"
                  style={{ height: "450px", objectFit: "cover" }}
                />
                <div
                  className="position-absolute"
                  style={{ bottom: "-10px", right: "70px", zIndex: 2 }}
                >
                  <div className="position-relative">
                    <img
                      src={why2}
                      alt="Patient Care"
                      className="img-fluid rounded-4 shadow"
                      style={{ width: "250px" }}
                    />
                    <div
                      className="position-absolute top-50 start-50 translate-middle bg-warning rounded-circle d-flex justify-content-center align-items-center shadow"
                      style={{
                        width: "50px",
                        height: "50px",
                        cursor: "pointer",
                      }}
                    >
                      <i className="bi bi-play-fill fs-4 text-white"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-6 text-white">
              <p className="text-primary fw-bold mb-2">
                <i className="bi bi-heart-fill me-1"></i> WHY CHOOSE US
              </p>
              <h2 className="fw-bold mb-3">
                Where Compassion Meets Excellence
              </h2>
              <p className="mb-4" style={{ color: "rgba(255,255,255,0.8)" }}>
                We provide advanced orthopaedic and spine care with precision
                and empathy — helping you regain mobility and live pain‑free.
              </p>

              {[
                { num: "01", title: "Specialised Orthopaedic Expertise" },
                { num: "02", title: "Advanced Endoscopic Spine & Trauma Care" },
                { num: "03", title: "Comprehensive Rehab & Follow‑up" },
              ].map((item, index) => (
                <div key={index} className="d-flex mb-3">
                  <div
                    className="rounded-circle bg-white text-primary fw-bold d-flex justify-content-center align-items-center me-3"
                    style={{ width: "65px", height: "45px" }}
                  >
                    {item.num}
                  </div>
                  <div>
                    <h5 className="fw-semibold mb-1">{item.title}</h5>
                    <p
                      className="mb-0"
                      style={{ color: "rgba(255,255,255,0.8)" }}
                    >
                      {index === 0 &&
                        "Years of experience in complex trauma, arthroscopy, and joint replacement."}
                      {index === 1 &&
                        "Minimally invasive techniques including UBE & transforaminal endoscopic spine surgery."}
                      {index === 2 &&
                        "Tailored physiotherapy and long‑term recovery planning for sustained outcomes."}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div
          className="position-absolute top-0 start-0 w-100 h-100"
          style={{
            background:
              "url('/images/medical-pattern.png') no-repeat center center",
            backgroundSize: "cover",
            opacity: 0.1,
            zIndex: 0,
          }}
        ></div>
      </section>

      <section className="py-5 bg-white position-relative overflow-hidden">
        <div className="container">
          <div className="row align-items-center gy-5">
            <div className="col-lg-6 position-relative">
              <div className="position-relative">
                <img
                  src={img1}
                  alt="Clinic"
                  className="img-fluid rounded shadow w-60"
                />
                <div
                  className="position-absolute top-0 start-0 bg-primary text-white d-flex align-items-center justify-content-center fw-bold"
                  style={{
                    width: "30px",
                    height: "100%",
                    writingMode: "vertical-rl",
                    textOrientation: "mixed",
                    transform: "rotate(180deg)",
                    fontSize: "12px",
                    letterSpacing: "1px",
                  }}
                >
                  12+ YEARS EXPERIENCE
                </div>
                <img
                  src={img2}
                  alt="Team"
                  className="img-fluid rounded shadow position-absolute"
                  style={{
                    bottom: "-20px",
                    right: "40px",
                    width: "30%",
                    border: "4px solid white",
                  }}
                />
              </div>
            </div>

            <div className="col-lg-5">
              <span
                className="px-3 py-1 rounded-pill border border-primary text-primary fw-semibold"
                style={{ backgroundColor: "#f5f9ff" }}
              >
                <i className="bi bi-heart-fill text-primary me-1"></i> About
              </span>
              <h2 className="fw-bold mb-3 mt-3">
                Orthopaedic & Spine Care You Can Trust
              </h2>
              <p className="text-muted mb-3" style={{ maxWidth: "600px" }}>
                Dr. Samal is associated with multiple reputed centres in
                Bhubaneswar:
              </p>
              <ul className="text-muted mb-4">
                <li>
                  <strong>Ortho Spine Care</strong> — B13 HIG Duplex, Near BDA
                  Colony, Baramunda, Bhubaneswar
                </li>
                {/* <li>
                  <strong>SUM Ultimate Medicare</strong>, Kalinga Nagar,
                  Bhubaneswar
                </li> */}
                <li>
                  <strong>KIMS Super Speciality Centre & Cancer Centre</strong>,
                  Bhubaneswar (Orthopaedics)
                </li>
              </ul>
              <div className="row mb-4">
                <div className="col-sm-6">
                  <ul className="list-unstyled mb-0">
                    <li>✅ Complex Trauma (Pelvis & Acetabulum)</li>
                    <li>✅ Endoscopic Spine (UBE, Transforaminal)</li>
                    <li>✅ Joint Replacement (TKR/THR)</li>
                  </ul>
                </div>
                <div className="col-sm-6">
                  <ul className="list-unstyled mb-0">
                    <li>✅ Arthroscopy & Sports Medicine</li>
                    <li>✅ Patient‑centred, minimally invasive care</li>
                    <li>✅ Transparent, ethical treatment</li>
                  </ul>
                </div>
              </div>
              <div className="d-flex align-items-center">
                <div>
                  <p className="mb-1 fw-semibold">
                    Consultant Orthopaedic & Spine Surgeon
                  </p>
                  <p className="mb-0 text-muted">Dr. Puspak Samal</p>
                </div>
              </div>
              <a
                href="https://indiahealthsystem.com/"
                className="btn btn-outline-primary mt-4"
              >
                BOOK APPOINTMENT →
              </a>
              <div className="mt-3 small text-muted">
                ★ Rated <strong>4.9/5</strong> by patients (615+ ratings, Ortho
                Spine Care listing)
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AboutSection;
